module.exports = __webpack_public_path__ + "img/pc1.40dd75a7.png";